export const IN_MY_PLAN = 'in_my_plan'
export const IN_MY_WISH_LIST = 'in_my_wish_list'
